import { AuditTimeline } from '../../components/AuditTimeline';
import { useHistory } from '../../components/use-history';

/** The owner's whole history: field edits are audited against `entityType: 'owner'`. Ownership transfers show on the truck's own History tab instead — they're audited against `entityType: 'truck'`. */
export function OwnerHistoryTab({ ownerId }: { ownerId: string }) {
  const state = useHistory('owner', ownerId, true);
  return <AuditTimeline state={state} />;
}
